export default __webpack_public_path__ + "locales/fi/ChangeUserStatusDialog.json?hash=c94389077a49c1daab5622166d70a475";